import request from '@/common/api'
import { HOSTS } from '@/common/utils/env'
import { MerchantCategoryRuleItem } from '@/pages/rule/utils/types'
import { RulePackageRes, SubmitRulePackage } from './types'


/** 品类列表 */
export const fetchMerchantCategoryList = () => request.get<MerchantCategoryRuleItem[]>(`${HOSTS.BASE}/api/entweb/category/merchant/list`)

/** 余额批次列表 */
export const fetchBalanceBatchList = (params: {pageNo: number, pageSize: number}) => request.get<{
  result: {batchName:string, batchNo: string}[]
}>(`${HOSTS.BASE}/api/entweb/balanceBatch/list`, { params })


/** 员工列表 */
export const fetchStaffList = (params: {
  pageNo: number;
  keyword: string;
  pageSize: number;
}) => request.get<{
  result: {name:string, staffId: string, email: string}[]
}>(`${HOSTS.BASE}/api/entweb/staff/search`, { params: { needDepartmentInfo: false, ...params } })


/** 部门列表 */
export const fetchDepartmentList = (params: {
  pageNo: number;
  keyword: string;
  pageSize: number;
}) => request.get<{
  result: {name:string, id: number, namePath: string}[]
}>(`${HOSTS.BASE}/api/entweb/department/search`, { params: { needNamePath: true, ...params } })

/** 分组列表 */
export const fetchGroupList = (params: {
  pageNo: number;
  keyword: string;
  pageSize: number;
}) => request.get<{
  result: {name:string, id: number, description?: string}[]
}>(`${HOSTS.BASE}/api/entweb/group/search`, { params })

/** 部门列表 */
export const fetchRuleDetail = (
  rulePackageId: number | string
) => request.get<RulePackageRes>(`${HOSTS.BASE}/api/entweb/rulePackage/detail`, { params: { rulePackageId } })

/** 新建/创建规则 */
export const createRule = async (body: SubmitRulePackage, ruleId?: string  | number) => {
  const isUpdate = Number(ruleId) > 0
  const path = isUpdate ? '/api/entweb/rulePackage/update' : '/api/entweb/rulePackage/create'
  const data = isUpdate ? { ...body, rulePackageId: ruleId } : body
  return request.post(`${HOSTS.BASE}${path}`, data)
}

/** 门店列表 */
export const fetchShopList = (params: {
  pageNo: number;
  shopName: string;
  pageSize: number;
}) => {
  if (!params.shopName) {
    return Promise.resolve({ shopList: [] })
  }
  return request.get<{
    shopList: {shopId:string, shopName: string, shopAddress: string}[]
  }>(`${HOSTS.BASE}/api/entweb/rulePackage/shop/list`, { params })

}

/** 品牌列表 */
export const fetchBrandList = (params: {
  pageNo: number;
  brandName: string;
  pageSize: number;
}) => {
  if (!params.brandName) {
    return Promise.resolve({ brandList: [] })
  }
  return request.get<{
    brandList: {brandId:string, brandName: string}[]
  }>(`${HOSTS.BASE}/api/entweb/rulePackage/brand/list`, { params })
}